'use strict';

function positionContentInGrid() {
    $('.content-tile.grid-tile').each(function () {
        var content = this;

        var attrValue = $(content).attr('data-content-tile-attributes');

        var contentData = null;
        if (attrValue) {
            try {
                contentData = JSON.parse(attrValue);
            } catch (e) {
                return;
            }
        }

        if (!contentData) {
            return;
        }

        var contentSize = parseInt(contentData.slotSize, 10);
        var contentOrientation = contentData.orientation;

        if (contentSize === 1) {
            $(content).addClass('grid-tile');
        } else if (contentSize === 2) {
            if (contentOrientation === 'horizontal') {
                $(content).addClass('grid-two-h-tiles');
            } else if (contentOrientation === 'vertical') {
                $(content).addClass('grid-two-v-tiles');
            }
        } else if (contentSize === 4) {
            $(content).addClass('grid-four-tiles');
        }
    });
}

$(document).ready(function () {
    positionContentInGrid();
    $(window).on('resize', positionContentInGrid);
});

module.exports = {
    positionContentInGrid: positionContentInGrid,
};
